import {
	createValueStorage,
	objectEntriesTyped,
	objectFromEntriesTyped,
} from '@bos/utils';
import { z } from 'zod';

type StorageKeys = keyof typeof STORAGE_KEYS;

// Add additional keys here when needed.
const STORAGE_KEYS = {
	redirectURL: 'redirectURL',
} as const;

// Add additional key schemas here.
const valhallaStorageSchema = z.object({
	[STORAGE_KEYS.redirectURL]: z.string(),
});

const createStorageForKey = <TKey extends StorageKeys>(key: TKey) => {
	const keyStr = STORAGE_KEYS[key];
	const fieldSchema = valhallaStorageSchema.shape[keyStr];
	const singleFieldSchema = z.object({ [keyStr]: fieldSchema });

	return createValueStorage(keyStr, singleFieldSchema);
};

const storages: Record<
	StorageKeys,
	ReturnType<typeof createStorageForKey>
> = objectFromEntriesTyped(
	objectEntriesTyped(STORAGE_KEYS).map(([key]) => [
		key,
		createStorageForKey(key),
	]),
);

export const valhallaStorage = {
	...storages,
	clear: () => {
		Object.values(storages).forEach((storage) => storage.remove());
	},
};
